import { render, staticRenderFns } from "./YwlyView.vue?vue&type=template&id=461e1746&"
import script from "./YwlyView.vue?vue&type=script&lang=js&"
export * from "./YwlyView.vue?vue&type=script&lang=js&"
import style0 from "./YwlyView.vue?vue&type=style&index=0&id=461e1746&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports